import classNames from 'classnames';
import { ForwardedRef } from 'react';

import InfoIcon from '../icons/InfoIcon';
import BasicButton, { BasicButtonElement, BasicButtonProps } from './BasicButton';

import styles from '../../styles/buttons/control-button.module.css';

function InfoButton({
    className = null,
    ref: buttonRef = null,
    ...props
}: BasicButtonProps & { ref?: ForwardedRef<BasicButtonElement> | null }) {
    return (
        <BasicButton
            ref={buttonRef}
            className={classNames([styles.container, className])}
            {...props}
        >
            <InfoIcon className={styles.icon} />
        </BasicButton>
    );
}

export default InfoButton;
